// import React from 'react'
import AwsConfig from '../../Config/AwsConfig'

const MoviePosterCdn = url => {
  if (url) {
    const cdnurl = AwsConfig.movieCdnUrl
    if (url && !url.includes(cdnurl)) {
      url = cdnurl + url
      return url
    }

    return url
  }

  return ''
}

export default MoviePosterCdn
